import React from "react";
import { useHistory } from "react-router-dom";

import { Section } from "@sainsburys-tech/luna-section";
import { trackEvent, Card } from "@jsainsburyplc/id-ui-common";

import { scrollToTop } from "utils/scrollToTop";
import { passwordService } from "services/password.service";
import { getMyIdConfirmationDiffPasswordLink } from "utils/urls";
import { categoryTypes, actionTypes } from "constants/tracking";

import PageFormat from "components/PageFormat";
import MultiMissionLogo from "components/MultiMissionLogo";
import ResetPassword from "components/ResetPassword";

const trackSubmit = (action) => {
  trackEvent({
    category: categoryTypes.MY_ID_CONFIRMATION_DIFF_PW,
    label: "Save new password",
    action,
  });
};

const MyIdSetPasswordPage = () => {
  const history = useHistory();

  const onSubmit = async ({ password }, actions) => {
    const { setSubmitting, setStatus, setValues } = actions;
    try {
      setSubmitting(true);
      const response = await passwordService.myIdSetPassword(password);

      if (response.status === 204) {
        setSubmitting(false);
        trackSubmit(actionTypes.SUCCESS);
        history.push(getMyIdConfirmationDiffPasswordLink());
        return;
      }

      if (!response.ok || response.status === 400) {
        setSubmitting(false);
        const data = await response.json();
        const errorMessage = { code: data.code, message: data.statusText };
        throw errorMessage;
      }
    } catch ({ code, message }) {
      trackSubmit(actionTypes.ERROR);
      setStatus({
        isError: true,
        code,
        message,
      });
      setSubmitting(false);
      setValues({ password: "", confirmPassword: "" });
      scrollToTop();
    }
  };

  return (
    <PageFormat>
      <Section
        className="c-hero c-hero--center"
        style={{
          display: "flex",
          justifyContent: "center",
          flexDirection: "row",
        }}
      >
        <MultiMissionLogo />
      </Section>
      <Card>
        <h1 className="ln-u-h4">
          Nearly there, we just need you to set a new password
        </h1>
        <p>
          You now only need to use one password to log in to your Nectar and
          Sainsbury’s Groceries accounts.
        </p>
        <p>Please choose a new password:</p>
        <ResetPassword onSubmit={onSubmit} isMultiMission={true} />
      </Card>
    </PageFormat>
  );
};

export default MyIdSetPasswordPage;
